import { Fragment, ReactNode, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { cn } from 'utils/utils';

interface ModalProps {
  open: boolean;
  onClose?: VoidFunction;
  title: string;
  subtitle?: string;
  content: ReactNode;
  buttons?: ReactNode;
  center?: boolean;
}
const Modal = ({ open, onClose, title, subtitle, content, buttons = null, center = false }: ModalProps) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && onClose) {
        onClose();
      }
    };

    document.addEventListener('keyup', handleEscape);

    return () => {
      document.removeEventListener('keyup', handleEscape);
    };
  }, [onClose]);
  return (
    <Fragment>
      {open && (
        <Fragment>
          <div onClick={onClose} className='fixed inset-0 bg-grey800 opacity-50 z-1' />
          <div
            id='modal'
            role='dialog'
            aria-modal={true}
            className='min-h-[400px] w-[580px] p-10 max-lg:w-[90%] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl z-2'
          >
            {onClose && (
              <button
                onClick={onClose}
                className='cursor-pointer absolute top-4 right-4 p-1 rounded-full focus:outline-none focus:ring-1 focus:ring-gray-500 focus:ring-offset-2'
              >
                <XMarkIcon className='h-6 w-6 text-gray-500' />
              </button>
            )}

            <div
              className={cn('flex flex-col gap-3 min-h-[400px]', center && 'items-center justify-center text-center')}
            >
              {title && <div className='font-[MuseoSans900] text-2xl color-grey800'>{title}</div>}
              {subtitle && <div className='font-[MuseoSansCyrl] text-sm text-gray-600'>{subtitle}</div>}
              {content}
              {buttons}
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};
export default Modal;
